module.exports = __webpack_public_path__ + "img/1557614106923573250.b5fed19c.png";